angular.module('unica_relator.relator_controllers', [])

.controller('RelatorBasicController',
	function(
		$rootScope, $scope
	) {

	$scope.forms = {};

	$scope.changeRelatorAvatar = function() {
		$rootScope.relatorData.avatar_changed = true;
	};

});